<template>
    <div>

        <div class="col-md-12" v-if="viewno == 0">
            <div class="row">
                <div class="col-md-6">
                    <h3 class="page-header" style="margin-bottom: 0px;">
                        <i class="fa fa-building-o animated bounceInDown show-info"></i>
                        <span>Job List</span>
                    </h3>
                </div>
                <div class="col-md-6 text-end">
                    <button class="btn btn-primary mt-20" @click="refresh()">Refresh</button>
                </div>
            </div>
            <div class=" col-md-12 row">
                <div class="col-md-3">
                    <label class="control-label">Title</label>
                    <input class="form-control form-cascade-control input-small" v-model="title" type="text" />
                </div>
                <div class="col-md-3">
                    <label class="control-label">City</label>
                    <input class="form-control form-cascade-control input-small" v-model="city" type="text" />
                </div>
              
                <!-- <div class="col-md-3">
                    <label class="control-label">Buy / Rent</label>
                     <select class="form-control form-cascade-control input-small" v-model="buyrent">
                        <option :value="1">Buy</option>
                        <option :value="2">Rent</option>
                    </select>
                </div> -->
            </div>
            <div class="col-md-12 mt-20">
                <button class="btn btn-primary btn-sm" @click="search()">Submit</button>
                <button class="btn btn-danger btn-sm" @click="cancel()">Cancel</button>
            </div>
            <div class="col-md-12 table-responsive" style="padding:0px;">
                <div class="panel">
                    <div class="panel-body table" style="overflow-x:auto;padding-left:0px">
                        <table class="table table-bordered table-font"
                            style="margin-bottom:0;font-size:15px!important;">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Company</th>
                                    <th>City</th>
                                    <th>Salary</th>
                                    <th>Job Type</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in alljobs" :key="item.id">
                                   <td>{{ index+1 }}</td>
                                   <td>{{ item.title ? item.title :'N/A' }}</td>
                                   <td>{{ item.companyname ? item.companyname : 'N/A' }}</td>
                                   <td>{{ item.cityname ? item.cityname : 'N/A' }}</td>
                                   <td>{{ item.salary ? item.salary : 'N/A' }}</td>
                                   <td>{{ item.jobtype== 1 ?'Full Time' : (item.jobtype== 2 ? 'Part Time' : 'N/A') }}</td>
                                   <td>{{ item.description ? item.description : 'N/A' }}</td>
                                  <td>
                                    <button class="btn btn-primary btn-sm" @click="editFun(item)">Edit</button>
                                    <button class="btn btn-danger btn-sm" @click="deleteFun(item)">Delete</button>
                                  </td>
                                   
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-12" style="margin-top: 20px">
                <nav aria-label="Page navigation example" style="text-align: right !important">
                    <paginate style="margin: 0px !important; float: right" :page-count="noofpages"
                        :click-handler="clickCallback" :prev-text="'&laquo;'" :next-text="'&raquo;'"
                        :container-class="'pagination'">
                    </paginate>
                </nav>
            </div>
        </div>
        <div v-if="viewno == 1">
            <create-job :editjob="editjob" @close="this.cancel"></create-job>
        </div>
        <!-- <div v-if="viewno == 2">
            <upload-images :editjob="editjob" @close="this.cancel"></upload-images>
        </div> -->
    </div>
</template>
<script>
import Paginate from "vuejs-paginate";
import { mapGetters } from 'vuex'
import axios from 'axios'
// import PropertyForm from "./PropertyForm.vue";
import Constants from "../../components/utilities/Constants.vue";
import CreateJob from "./CreateJob.vue";
// import UploadImages from "../upload/UploadImages.vue";


export default {
    mixins: [Constants],
    components: { Paginate, CreateJob },
    data() {
        return {
            currentpage: 1,
            noofrec: 10,
            count: 0,
            alljobs: [],
            viewno: 0,
            editjob: null,
            title: '',
            city: '',
        }
    },
    computed: {
        ...mapGetters([
            ''
        ]),
        noofpages() {
            return Math.ceil(parseInt(this.count) / parseInt(this.noofrec))
        }

    },
    mounted() {
        this.refresh()
    },
    methods: {
        clickCallback(currentpage) {
            this.currentpage = currentpage
            this.refresh();
        },
        search() {
            this.currentpage = 1
            if (this.title != '' || this.city != '') {
                this.refresh()
            }
        },
        refresh() {
            let param = {
                noofrec: this.noofrec, currentpage: this.currentpage,
                title: this.title, city: this.city, 
            }
            axios.post('api/jobs/lists', param)
                .then(response => {
                    this.count = response.data.count
                    this.alljobs = response.data.lists
                })
                .catch(error => {
                    console.log(error)
                })
        },
        editFun(item) {
            this.viewno = 1
            this.editjob = item
        },
        deleteFun(item){
            if(confirm('Do you want to delete it.')){
                let param = {id : item.id}
                axios.post('api/jobs/rolledback', param)
                .then(response => {
                    if(response.data.status){
                        this.refresh()
                    }else {
                        alert('Not deleted')
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
        cancel() {
            this.title = ''
            this.city = ''
            this.viewno = 0
            this.editjob = null
            this.refresh()
        },

    },
}
</script>
